// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"427":"1ac91098","428":"664989eb","554":"7f712011","921":"4e0fb865"}[chunkId] + ".chunk.js";
};